import { memo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { hotjar } from "react-hotjar";
import { canTrackingEmbeddedRoute } from "../utils";
import useAuthState from "@/shared/presentation/context-api/hooks/get-auth-state";
var HotjarTrackingWrapper = function (_a) {
    var initialized = _a.initialized, children = _a.children, isRouteEmbedded = _a.isRouteEmbedded;
    var _b = useLocation(), pathname = _b.pathname, search = _b.search;
    var user = useAuthState().user;
    var isLogin = pathname === "/login";
    var hasQueryParamsRoute = !!search;
    useEffect(function () {
        if (initialized && !isRouteEmbedded) {
            hotjar.stateChange(pathname + search);
            hotjar.identify(user.rockId, {
                rockId: user.rockId,
                userId: user.userId,
            });
        }
        if (initialized &&
            isRouteEmbedded &&
            canTrackingEmbeddedRoute(isLogin, hasQueryParamsRoute)) {
            hotjar.stateChange(pathname + search);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized, pathname, search, isRouteEmbedded]);
    return children;
};
export default memo(HotjarTrackingWrapper);
